import { render, staticRenderFns } from "./user-circle.vue?vue&type=template&id=060a7ee8&"
import script from "./user-circle.vue?vue&type=script&lang=js&"
export * from "./user-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports